/* eslint-disable no-debugger */
import { formattedDate } from '@helper/util/formattedDate'

import {
  IParamsToSend,
  IModifyParamsToSend
} from '@base/@types/providers/Alert/AlertPurchaseProvider'

export const paramsAlertToSendMapping = ({
  name,
  value,
  compareName,
  fieldName,
  paramsToSend
}: IModifyParamsToSend) => {
  const paramsToSendFormatted: IParamsToSend = { ...paramsToSend }

  if (
    name === 'initialDate' ||
    name === 'finalDate' ||
    name === 'periodoIds' ||
    name === 'periodoSelectIds'
  ) {
    paramsToSendFormatted.periodo = {
      inicio:
        name === 'initialDate'
          ? formattedDate(String(value))
          : paramsToSendFormatted.periodo.inicio,
      final:
        name === 'finalDate'
          ? formattedDate(String(value))
          : paramsToSendFormatted.periodo.final,
      agrupar:
        name === 'periodoIds' ? value : paramsToSendFormatted.periodo.agrupar
    }

    return paramsToSendFormatted
  }

  if (name === compareName && Array.isArray(value)) {
    paramsToSendFormatted[fieldName as keyof IParamsToSend] = value.map(
      item => item.value
    )
  }
  return paramsToSendFormatted
}
